import { post } from './index';
//获取图表数据接口
export const getChartsData = data => {
  return post({
    url: '/pm/query',
    data
  });
};

//导出csv
export const exportData = data => {
  return post({
    url: '/pm/export',
    data,
    timeout: 0
    // responseType: 'blob',
  });
};

//获取服务器的一些配置
export const getServerConfig = () => {
  return post({
    url: '/pm/config'
  });
};

//更新图表数据，用与增量更新
export const updateChartsData = data => {
  return post({
    url: '/pm/refresh',
    data
  });
};